import React, { useEffect, useState } from 'react';

import Skeleton from 'react-loading-skeleton';
import { Controller } from 'react-hook-form';

import { makeStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import StopsService from './../../../../services/api/stops';

const useStyles = makeStyles({
  select: {
    width: '100%',
    marginTop: '1em',
    marginBottom: '1em',
  },
  formControl: {
    width: '100%',
    marginTop: '1.1em',
  },
});

export const StopSelect = (props) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [stops, setStops] = useState([]);
  const [stopId, setStopID] = useState(0);

  useEffect(() => {
    let isCancelled = false;

    setIsLoading(true);

    setTimeout(function () {
      //Request
      StopsService.getList()
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          //
          if (response && response.Data !== undefined) {
            if (!isCancelled) {
              setStopID(props.stopId);
              setIsLoading(false);
              setStops(response.Data);
            }
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }, 1000);

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleChange = (event) => {
    setStopID(event.target.value);
    props.parentCallback(event.target.value);
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Skeleton count={1} height={50} className={classes.formControl} />
      ) : (
        <Controller
          as={
            <FormControl variant="outlined" className={classes.select}>
              <InputLabel id="routeLabel">Parada</InputLabel>
              <Select
                labelId="routeLabel"
                id="stop"
                value={stopId}
                autoWidth
                defaultValue=""
                onChange={handleChange}
                label="Paradas"
              >
                {stops.map((stop) => (
                  <MenuItem key={stop.ParadaID} value={stop.ParadaID}>
                    {stop.Nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
          className={classes.select}
          name="stop"
          control={props.control}
          error={props.error}
        />
      )}
    </React.Fragment>
  );
};
